import { h } from 'preact';

export function IconChevronLeftNarrow({ width = 22, height = 50, fill = 'currentColor' }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 22 50"
      width={width}
      height={height}
      class="icon-chevron-left-narrow"
    >
      <path
        d="M21.3408 46.3636L5.3181 25.0006L21.3408 3.63643C22.094 2.63223 21.8903 1.20762 20.8862 0.454589C19.8821 -0.298635 18.4574 -0.0948257 17.7043 0.90918L0.659101 23.637C0.0530454 24.445 0.0530454 25.5562 0.659101 26.3642L17.7044 49.0908C18.1509 49.6862 18.8334 50.0001 19.5245 50.0001C19.9989 50.0001 20.4775 49.852 20.8863 49.5454C21.8905 48.7922 22.094 47.3677 21.3408 46.3636Z"
        fill={fill}
      />
    </svg>
  );
}
